<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>使用期限：<span style="font-weight: bold;">{{ $store.getters.user.ExpiredTime }}</span></v-toolbar-title>
    </v-toolbar>
    <v-data-table
        v-bind:headers="headers"
        v-model="items"
        v-bind:search="search"
        hide-actions
        no-data-text="目前無可用資料"
        class="elevation-1"
        style="background-color: #fff;"
      >
      <template slot="items" scope="props">
        <td>{{ props.item.action }}</td>
        <td class="text-xs-right">{{ props.item.endtime }}</td>
        <td class="text-xs-right">{{ fromNow(props.item.time) }}</td>
      </template>
    </v-data-table>

    <div class="mt-3" style="text-align: center;">
      <v-pagination v-bind:length.number="pageCount" v-model="page" />
    </div>
  </div>
</template>

<script>
  import api from '../api'

  export default {

    name: 'MyPeriod',

    data () {
      return {
        search: '',
        headers: [
          {
            text: '動作',
            left: true,
            sortable: true,
            value: 'action'
          },
          { text: '到期日', value: 'endtime' },
          { text: '時間', value: 'time' }
        ],
        items: [],
        page: 1,
        pageCount: 0
      }
    },

    created () {
      this.getData()
      this.$watch('page', () => {
        this.getData()
      })
    },

    methods: {
      getData () {
        var self = this
        api.Product
          .Record(self.page)
          .then((res) => {
            self.pageCount = res.data.PageCount
            self.items = []
            res.data.Data
            .forEach((el) => {
              self.items.push({
                value: false,
                action: el.Name.replace('[', '〈').replace(']', '〉'),
                endtime: el.EndTime,
                time: el.CreateTime
              })
            })
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MyPeriod.vue?51a8c8da